import { IProduct } from '@interfaces';

import styles from '@components/common/products/product.styles';
import { WPImage } from '@v2/utils/image';
import IconCheckmark from '@img/icons/checkmark-blue.svg';

export default function BundleIncludes({ bundle }: { bundle?: IProduct }) {

    return (
        <div className={styles.bundleIncludes}>
            <div className='brain-section'>
                <div className='description-container'>
                    {bundle.subcategory === 'age_bundle' && <div className='title'>what they need, when it matters most:</div>}
                    {bundle.subcategory === 'age_bundle' &&<div className='age'>{`At ${bundle.ageMin}${bundle.ageMax ? `-${bundle.ageMax}` : '+'} months`}</div>}
                    {bundle.subcategory === 'variety_pack' &&<div className='age'>{`${bundle.title}`}</div>}
                    <div className='description'>{bundle.developmental.description}</div>
                </div>
                {bundle.subcategory === 'age_bundle' &&
                    <div className='brain-container'>
                        <WPImage src={bundle.developmental.brainImage} alt={bundle.developmental.brainText} />
                    </div>
                }
            </div>
            <div className='includes-section'>
                <h3>bundle includes</h3>
                <div className='bundle-items'>
                    {bundle.products.map((product) => {
                        return <div className='bundle-item'>{`${product.size} x ${product.title}`}</div>
                    })}
                </div>
                <div className='nutrient-items'>
                    {bundle.nutrients.map((nutrient) => {
                        return (
                            <div className='nutrient-item'>
                                <img src={IconCheckmark} alt=''/>
                                {nutrient.source}
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    );
}